export const translations = {
  BACK: {
    sv: 'Tillbaka',
    en: 'Back',
    da: 'Tilbage',
    fi: 'Takaisin',
    no: 'Tilbake',
  },
};

export type PnMenuTextProp = keyof typeof translations;
